import * as React from 'react';
import { SingleKeyValueComponent } from '../common/types';
import { SelectType, SelectCommonProps } from '../common/select/types';
import { SelectBaseComponent } from '../common/select/select-base-component';

/**
 * SelectSingle component let you choose one option from list of options.
 *
 * > It supports common InputControlContext component.
 */
export interface SelectSingleProps extends SingleKeyValueComponent<number>, SelectCommonProps {
  /**
   * Reset to previous selected value when the field is cleared.
   * Default is false.
   */
  resetPreviousValueWhenEmpty?: boolean;
}

export class SelectSingle extends React.Component<SelectSingleProps> {
  public render() {
    return <SelectBaseComponent
      {...this.props}
      selectType={SelectType.single}
      valueItems={!!this.props.valueItem ? [this.props.valueItem] : []}
    />;
  }
}
